import React from "react";
import { Link } from "react-router-dom";
import { FaHeart, FaUserCheck } from "react-icons/fa";
import "./ProfileCard.css";

function ProfileCard({ user, baseurl }) {
  const userId = user.User_id || user.id || user.user_id;

  // Get display name
  const getDisplayName = () => {
    return user.firstname || user.first_name || user.username || 'User';
  };

  // Get profile image
  const getProfileImage = () => {
    if (user.pic) {
      return `${baseurl}${user.pic}`;
    }
    return `https://ui-avatars.com/api/?name=${encodeURIComponent(getDisplayName())}&background=ff0055&color=fff&size=200`;
  };

  // Format Profile ID
  const formatProfileId = () => {
    if (user.ref) return `${String(user.ref).padStart(6, '0')}`;
    if (user.profile_id) return `${String(user.profile_id).padStart(6, '0')}`;
    if (user.refer) return `${String(user.refer).padStart(6, '0')}`;
    return user.User_id || user.user_id || user.id || 'N/A';
  };

  return (
    <Link to={`/user-profile/${userId}`} className="res-card-link">
      <div className="res-card">
        
        {/* Image Section */}
        <div className="res-card-img-box">
          <img
            src={getProfileImage()}
            alt={getDisplayName()}
            className="res-card-img"
          />
          <div className="res-card-img-fade"></div>
          
          <div className="res-card-verified-tag">
            <FaUserCheck /> Verified
          </div>
          
          <div className="res-card-id-tag">
            ID: {formatProfileId()}
          </div>
        </div>

        {/* Body */}
        <div className="res-card-body">
          <div className="res-card-top-row">
            <h3 className="res-card-name">{getDisplayName()}</h3>
            <FaHeart className="res-card-heart-icon" />
          </div>

          <div className="res-chips">
            {user.age && <span className="res-chip">🎂 {user.age} yrs</span>}
            {user.district && <span className="res-chip">📍 {user.district}</span>}
            {user.caste && <span className="res-chip">🙏 {user.caste}</span>}
            {user.gender && (
              <span className="res-chip">
                {user.gender === "Male" ? "👨" : "👩"} {user.gender}
              </span>
            )}
          </div>

          <div className="res-card-footer">
            <span className="res-view-btn">View Profile →</span>
            <div className="res-footer-heart">❤️</div>
          </div>
        </div>
      </div>
    </Link>
  );
}

export default ProfileCard;